import React from 'react';
import { Spring, config } from 'react-spring/renderprops'
import Konva from 'konva';
import { Arc, Stage, Layer, Text, Shape, Circle } from 'react-konva';
import ReactResizeDetector from 'react-resize-detector';
import ResizeableStage from 'charts/ResizeableStage';
import MetricFormatter from 'dashboards/MetricFormatter'
import ReactDOMServer from 'react-dom/server';

class ChartGoal extends React.Component {
  constructor(props) {
    super(props);

    this.projectedStrokeScalar = .04
    this.currentStrokeScalar = .08
    this.metricNameTextSizeScalar = .15
    this.currentTextSizeScalar = .2
    this.projectedTextSizeScalar = .13
    this.goalTextSizeScalar = .13

    //clamp the angle at max 360 deg
    this.currentToGoalAngle = Math.min((this.props.goal > 0 ? this.props.current / this.props.goal : 0) * 360, 360)
    this.projectedToGoalAngle = Math.min((this.props.goal > 0 ? this.props.projected / this.props.goal : 0) * 360, 360)

    this.goodCurrentColor = "#42ba96"
    this.goodProjectedColor = "#9ed8c6"
    this.badCurrentColor = "#c76650"
    this.badProjectedColor = "#da7159"
    this.unlockedCurrentColor = "#358fc1"

    if (this.props.goalLocked) {
      if (this.props.negative) {
        this.currentColor = this.badCurrentColor;
      } else {
        this.currentColor = this.goodCurrentColor;
      }
    } else {
      this.currentColor = this.unlockedCurrentColor;
    }

    if (this.props.negative) {
      this.projectedColor = this.badProjectedColor;
    } else {
      this.projectedColor = this.goodProjectedColor;
    }
  }

  componentDidMount() {
  }

  render() {
    const Formatter = this.props.formatter;
    const formattedCurrent = ReactDOMServer.renderToString(<Formatter value={this.props.current} baseCurrency={this.props.baseCurrency} displayCurrency={this.props.displayCurrency} />)
    const formattedProjected = ReactDOMServer.renderToString(<Formatter value={this.props.projected} baseCurrency={this.props.baseCurrency} displayCurrency={this.props.displayCurrency} />)
    const formattedGoal = ReactDOMServer.renderToString(<Formatter value={this.props.goal} baseCurrency={this.props.baseCurrency} displayCurrency={this.props.displayCurrency} />)
    return (
      <div className="p-1">
        <ResizeableStage maxHeight={400} pdfDim={this.props.pdfDim} render={(width, height) => {
          const wOrH = (height > width ? width : height);
          const projectedStrokeWidth = this.projectedStrokeScalar * wOrH;
          const currentStrokeWidth = this.currentStrokeScalar * wOrH;
          const radius = (wOrH / 2.1) - (currentStrokeWidth / 1.8);

          const hW = width / 2;
          const hH = height / 2;
          return (
            <>
              <Circle
                radius={radius}
                fill="#EEEEEE"
                x={hW}
                y={hH}
              />

              {!this.props.goal || this.props.goal == 0 ?
                <Shape
                  sceneFunc={(context, shape) => {
                    context.beginPath();
                    context.font = `${radius * this.metricNameTextSizeScalar}px visby-medium`;
                    context.fillStyle = "#212348";
                    context.textAlign = 'center';
                    context.fillText(this.props.metricName, width / 2, hH / 1.4, width);
                  }}
                />
              :
                <Shape
                  sceneFunc={(context, shape) => {
                    context.beginPath();
                    context.font = `${radius * this.metricNameTextSizeScalar}px visby-medium`;
                    context.fillStyle = "#212348";
                    context.textAlign = 'center';
                    context.fillText(this.props.metricName, width / 2, hH - (radius / 2.2), width);
                  }}
                />
              }

              {!this.props.goal || this.props.goal == 0 ?
                <Shape
                  sceneFunc={(context, shape) => {
                    context.beginPath();
                    context.font = `${radius * this.currentTextSizeScalar }px visby-extra-bold`;
                    context.fillStyle = "#212348";
                    context.textAlign = 'center';
                    // context.fillText(formattedCurrent, width / 2, hH - (radius / 6), width);
                    context.fillText(formattedCurrent,  width / 2, hH / 1, width);
                  }}
                />
              :
                <Shape
                  sceneFunc={(context, shape) => {
                    context.beginPath();
                    context.font = `${radius * this.currentTextSizeScalar}px visby-extra-bold`;
                    context.fillStyle = "#212348";
                    context.textAlign = 'center';
                    context.fillText(formattedCurrent, width / 2, hH - (radius / 5.6), width);
                  }}
                />
              }

              {!this.props.goal || this.props.goal == 0 ?
                <Shape
                  sceneFunc={(context, shape) => {
                    context.beginPath();
                    context.font = `${radius * this.projectedTextSizeScalar}px nunito-regular`;
                    context.fillStyle = "#212348";
                    context.textAlign = 'center';
                    context.fillText(`Projected: ${formattedProjected}`, width / 2, hH / 0.8, width);
                  }}
                />
              :
                <Shape
                  sceneFunc={(context, shape) => {
                    context.beginPath();
                    context.font = `${radius * this.projectedTextSizeScalar}px nunito-regular`;
                    context.fillStyle = "#212348";
                    context.textAlign = 'center';
                    context.fillText(`Projected: ${formattedProjected}`, width / 2, hH + (radius / 5), width);
                  }}
                />
              }

              {!this.props.goal || this.props.goal == 0 ?
                <></>
                :
                <Shape
                  sceneFunc={(context, shape) => {
                    context.beginPath();
                    context.font = `${radius * this.goalTextSizeScalar}px nunito-bold`;
                    context.fillStyle = "#212348";
                    context.textAlign = 'center';
                    context.fillText(`Goal: ${formattedGoal}`, width / 2, hH + (radius / 2.3), width);
                  }}
                />
              }

              { !this.props.goal || this.props.goal == 0 ? (
                <></>
              ) : (
                <>
                  <Spring from={!this.props.pdfDim ? { angle: 0 } : undefined} to={{ angle: this.projectedToGoalAngle + 1 }}>
                    {
                      props => (
                        <Arc
                          x={hW}
                          y={hH}
                          innerRadius={radius}
                          outerRadius={radius}
                          angle={props.angle}
                          fill="rgba(0,0,0,0)"
                          stroke={this.projectedColor}
                          lineCap="round"
                          lineJoin="round"
                          rotation={-90}
                          strokeWidth={projectedStrokeWidth}
                        />
                      )
                    }
                  </Spring>
                  <Spring delay={2000} from={!this.props.pdfDim ? { angle: 0 } : undefined} to={{ angle: this.currentToGoalAngle + 1 }}>
                    {
                      props => (
                        <Arc
                          x={hW}
                          y={hH}
                          innerRadius={radius}
                          outerRadius={radius}
                          angle={props.angle}
                          fill="rgba(0,0,0,0)"
                          stroke={this.currentColor}
                          lineCap="round"
                          lineJoin="round"
                          rotation={-90}
                          strokeWidth={currentStrokeWidth}
                          />
                        )
                      }
                  </Spring>
                </>
              )}
            </>
          )
        }}>
        </ResizeableStage>
      </div>
    )
  }
}

export default ChartGoal;
